import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-VIP_button_sale1",
  "use": "icon-VIP_button_sale1-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-VIP_button_sale1\"><path d=\"m6 12c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6zm-2.21-5.22 2.82 2.91s.04.03.06.04c.02 0 .05.01.07.01s.05 0 .07-.01c.02 0 .04-.02.06-.04l2.82-2.91s.04-.05.04-.08 0-.06-.01-.09-.04-.05-.06-.07-.06-.03-.1-.03h-1.39s-.08-.01-.12-.04c-.03-.03-.05-.06-.06-.1-.11-.68-.74-3.68-3.71-4.13-.04 0-.08 0-.11.01-.04.02-.06.04-.08.07s-.02.07-.01.1c0 .03.03.07.06.09.51.36 1.18 1.06 1.37 2.3.07.5.1 1.01.1 1.52 0 .04-.02.08-.05.11s-.08.05-.13.05h-1.52s-.07 0-.1.03c-.03.02-.05.04-.07.07-.01.03-.02.06-.01.09 0 .03.02.06.04.08z\" fill=\"#5a4f45\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/VIP_button_sale1.svg
// module id = Mrha
// module chunks = 87